import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import './EventDetail.css';

const NavratriGarba = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <PageBanner title="Navaratri Garba Night" />

            <div className="event-detail-container">
                <div className="event-detail-grid">
                    {/* Left Column - Event Info */}
                    <div className="event-info-column">
                        <div className="event-header">
                            <span className="event-category">Community Event</span>
                            <h1 className="event-title">Navaratri Garba Night</h1>
                            <p className="event-subtitle">Bombay Style Dandiya Raas with Live Singer & Band</p>
                        </div>

                        {/* Quick Info Cards */}
                        <div className="event-quick-info">
                            <div className="info-card">
                                <i className="fa fa-calendar"></i>
                                <div>
                                    <span className="info-label">Date</span>
                                    <span className="info-value">Friday, October 16, 2026</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-clock"></i>
                                <div>
                                    <span className="info-label">Time</span>
                                    <span className="info-value">9:00 PM onwards</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-map-marker-alt"></i>
                                <div>
                                    <span className="info-label">Venue</span>
                                    <span className="info-value">Yugal Kunj, Duluth, GA</span>
                                </div>
                            </div>
                            <div className="info-card highlight">
                                <i className="fa fa-ticket-alt"></i>
                                <div>
                                    <span className="info-label">Entry</span>
                                    <span className="info-value">Free Entry</span>
                                </div>
                            </div>
                        </div>

                        {/* Event Highlights */}
                        <div className="event-section">
                            <h3 className="section-title">Event Highlights</h3>
                            <ul className="highlights-list">
                                <li><i className="fa fa-check-circle"></i>Live Singer & Band – Featuring Desi Roots and Rangeet</li>
                                <li><i className="fa fa-check-circle"></i>Bombay Style Dandiya Raas</li>
                                <li><i className="fa fa-check-circle"></i>Ambe Ma Aarti</li>
                                <li><i className="fa fa-check-circle"></i>Food Available for Purchase</li>
                                <li><i className="fa fa-check-circle"></i>Free Parking</li>
                            </ul>
                        </div>

                        {/* Action Buttons */}
                        <div className="event-actions">
                            <a
                                href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-primary"
                            >
                                <i className="fa fa-map-marker-alt"></i> Get Directions
                            </a>
                            <a
                                href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/554c4ac9_navratri-garba-2026.jpeg"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-secondary"
                            >
                                <i className="fa fa-download"></i> Download Flyer
                            </a>
                        </div>
                    </div>

                    {/* Right Column - Flyer */}
                    <div className="event-flyer-column">
                        <div className="flyer-wrapper">
                            <img
                                src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/554c4ac9_navratri-garba-2026.jpeg"
                                alt="Navaratri Garba Night"
                                className="event-flyer-image"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default NavratriGarba;
